<!-- 用户管理 -->
<template>
  <div>
    <div class="mainBar">
      <!-- 封装selectForm筛选 -->
      <el-form :inline="true">
        <el-form-item label="出诊名称:" style="margin: 0px 20px 0 0" size="small">
          <el-select v-model="listQuery.activeID" placeholder="请选择">
            <div v-for="(item, index) in activeList" :key="index">
              <el-option :label="item.activeName" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名: " style="margin: 0 20px 0 0" size="small">
          <el-input v-model="listQuery.name" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号: " style="margin: 0 20px 0 0" size="small">
          <el-input v-model="listQuery.phone" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态:" style="margin: 0px 20px 0 0" size="small">
          <el-select v-model="listQuery.status" placeholder="请选择" clearable>
            <div v-for="(item, index) in statusList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>

        <!-- <el-button
        class="addBtn"
        type="primary"
        @click="search"
        size="small"
        v-waves
        style="margin: 0 0px 10 0"
        >搜索1</el-button
        >-->
        <el-button
          type="primary"
          @click="search"
          size="small"
          v-waves
          style="margin: 0 0px 10 0"
          class="addBtn"
        >搜索</el-button>
      </el-form>
    </div>
    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="invoiceUrl" slot-scope="{ row }">
          <el-image
            style="width: 60px; max-height: 60px"
            :src="row.invoiceUrl"
            :preview-src-list="[row.invoiceUrl]"
          ></el-image>
        </template>
        <!-- 0 待预约 1已预约 2已核销 -->
        <template slot="status" slot-scope="{ row }">
          <el-tag type="danger" effect="dark" size="mini" v-if="row.status === 0">待预约</el-tag>
          <el-tag type="success" effect="dark" size="mini" v-if="row.status == 1">已预约</el-tag>
          <el-tag type="info" effect="dark" size="mini" v-if="row.status == 2">已核销</el-tag>
          <el-tag type="info" effect="dark" size="mini" v-if="row.status == 3">已取消</el-tag>
        </template>

        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button class="editBtn" size="mini" type="text" @click="handleEdit(row)" primary>查看详情</el-button>
            <el-button
              class="editBtn"
              size="mini"
              type="text"
              @click="handleInvoice(row)"
              primary
              v-if="row.invoiceInfo || row.invoiceUrl"
            >
              {{
              row.invoiceUrl
              ? " 查看发票"
              : row.invoiceInfo
              ? " 开票申请"
              : "-"
              }}
            </el-button>
            <!-- v-if="row.status == 1" -->
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0)"
              @click="handleWriteOff(row)"
            >核销</el-button>
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0)"
              @click="handleDelete(row)"
            >删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 查询预约人弹窗 -->
    <el-dialog
      :title="dialogName"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      v-if="dialogVisible"
    >
      <el-form ref="form" :model="dialogForm" label-width="120px">
        <div
          class="ticketUser"
          style="background: #f5f7fa"
        >{{ dialogForm.ticketType }} X{{ dialogForm.num }}</div>
        <div v-for="item in ticketUser" :key="item.id" class="ticketUser">
          <div>用户身份：{{ item.name }} {{ item.idCard }}</div>
          <div>手机号： {{ item.phone }}</div>
        </div>
        <!-- <el-form-item label="备注">
          <el-input
            clearable
            v-model="dialogForm.des"
            placeholder="请输入"
          ></el-input>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" size="small" @click="dialogVisible = false">取 消</el-button>
        <!-- <el-button class="addBtn" size="small" type="primary" @click="save"
          >确 定</el-button
        >-->
      </div>
    </el-dialog>

    <!-- 开票弹窗 -->
    <el-dialog
      :title="dialogName"
      :visible.sync="dialogVisibleInvoice"
      :close-on-click-modal="false"
      v-if="dialogVisibleInvoice"
    >
      <el-form ref="form" :model="dialogForm" label-width="120px">
        <el-form-item label>
          <div>公司名称：{{ dialogForm.invoiceInfo.title || "-" }}</div>
          <div>公司地址：{{ dialogForm.invoiceInfo.companyAddress || "-" }}</div>
          <div>公司税号：{{ dialogForm.invoiceInfo.taxNumber || "-" }}</div>
          <div>开户银行：{{ dialogForm.invoiceInfo.bankName || "-" }}</div>
          <div>银行账号：{{ dialogForm.invoiceInfo.bankAccount || "-" }}</div>
          <div>联系电话：{{ dialogForm.invoiceInfo.telephone || "-" }}</div>
        </el-form-item>
        <el-form-item label="发票链接" required>
          <el-input clearable v-model="dialogForm.invoiceUrl" placeholder="发票地址"></el-input>
          <el-upload
            name="formData"
            class="upload-demo"
            :action="action"
            :on-success="
              (response) => {
                return handleSuccess(response);
              }
            "
            multiple
            :limit="1"
            :file-list="fileList"
          >
            <el-button size="mini" type="primary" style="padding: 9px 5px">上传发票</el-button>
            <div slot="tip" class="el-upload__tip">请上传发票</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" size="small" @click="dialogVisibleInvoice = false">取 消</el-button>
        <el-button class="addBtn" size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 核销门票弹窗 -->
    <el-dialog
      title="核销门票"
      :visible.sync="dialogVisibleWriteOff"
      :close-on-click-modal="false"
      v-if="dialogVisibleWriteOff"
    >
      <el-form ref="form" :model="dialogForm" label-width="120px">
        <el-form-item label="状态:" required>
          <el-select v-model="dialogForm.status" placeholder="请选择" style="width: 100%" clearable>
            <div v-for="(item, index) in statusList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input clearable v-model="dialogForm.des" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="核销人">
          <el-input disabled v-model="dialogForm.hexiaoID" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" size="small" @click="dialogVisibleWriteOff = false">取 消</el-button>
        <el-button class="addBtn" size="small" type="primary" @click="saveWriteOff">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import { mapState } from "vuex";
import { IP } from "@/services/config.js";
import { selectApi as selectInfo } from "@/services/information/list";
import {
  selectApi,
  deleteApi,
  updateApi
  // addexhibitionTicket,
} from "@/services/information/reservation";
import { selectApi as selectApiUser } from "@/services/information/reservationUser";
// import { selectexhibitionHall } from "@/services/exhibition/exhibitionHall";

export default {
  components: {
    ElTable
    // StoreToString,
  },
  // directives: {
  //   waves,
  // },
  async created() {
    if (this.userInfo.group_id !== 1) {
      let exhibitionInfo = await selectInfo({
        // exhibitionID: exhibitionHall.data[0]?.id || null,
        exhibitionID: this.userInfo.id,
        pageNumber: 1,
        pageSize: 10
      });
      this.activeList = exhibitionInfo.data;
      // this.listQuery.activeID = exhibitionInfo.data.map(item => item.id)[0];
    } else {
      let exhibitionInfo = await selectInfo({
        pageNumber: 1,
        pageSize: 10,
        exhibitionID: -1 //查询所有
      });
      this.activeList = exhibitionInfo.data;
    }

    this.getListData();
  },
  data() {
    return {
      activeList: [],
      action: IP + "/uploadFile/add",
      fileList: [],
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        name: "",
        activeID: ""
      },
      /* 表格数据 */
      tableData: [],
      storeList: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogVisibleInvoice: false,
      dialogForm: {
        invoiceInfo: {}
      },
      statusList: [
        // { id: 0, name: "待预约" },
        { id: 1, name: "已预约" },
        { id: 2, name: "已核销" },
        { id: 3, name: "已取消" }
      ],
      disableList: [
        { id: 0, name: "不跳转" },
        { id: 1, name: "跳转" }
      ],
      roleVisible: false,
      navData: [],
      checkedData: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      ticketUser: [],
      dialogVisibleWriteOff: false
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader,
    ...mapState(["userInfo"])
  },

  watch: {},
  methods: {
    async getListData() {
      this.loading = true;
      const { data, code, count } = await selectApi(this.listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },

    /* 搜索按钮 */
    async search() {
      this.getListData();
    },
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 查看预约人 */
    handleEdit(row) {
      console.log(row);
      this.dialogVisible = true;
      this.dialogName = "查看详情";
      this.dialogForm = JSON.parse(JSON.stringify(row));
      selectApiUser({
        ticketID: row.id
      }).then(res => {
        console.log("res", res);
        this.ticketUser = res.data;
      });
    },

    /* 上传发票 */
    handleInvoice(row) {
      this.dialogVisibleInvoice = true;
      this.dialogName = "开票";
      this.dialogForm = JSON.parse(JSON.stringify(row));
      this.dialogForm.invoiceInfo = JSON.parse(this.dialogForm.invoiceInfo);
    },

    handleSuccess(e) {
      console.log("handleSuccess", e);
      this.dialogForm.invoiceUrl = e.data;
      this.fileList = [];
      this.$message.success("上传成功，请继续操作");
    },
    save() {
      // //必填字段校验
      // if (!this.dialogForm.name || !this.dialogForm.phone) {
      //   this.$message.error("请填写必填字段");
      //   return;
      // }
      updateApi({
        // ...this.dialogForm,
        id: this.dialogForm.id,
        invoiceUrl: this.dialogForm.invoiceUrl
        // hexiaoID: `后台账号ID:${this.userInfo.id}操作`,
      }).then(res => {
        if (res.code === 200) {
          this.getListData();
          this.$message({
            type: "success",
            message: "编辑成功!"
          });
          this.dialogVisibleInvoice = false;
        }
      });
    },

    /* 核销门票 */
    handleWriteOff(row) {
      this.dialogVisibleWriteOff = true;
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },
    saveWriteOff() {
      updateApi({
        id: this.dialogForm.id,
        hexiaoID: `后台账号ID:${this.userInfo.id}操作`,
        status: this.dialogForm.status,
        des: this.dialogForm.des
      }).then(res => {
        if (res.code === 200) {
          this.getListData();
          this.$message({
            type: "success",
            message: "编辑成功!"
          });
          this.dialogVisibleWriteOff = false;
        }
      });
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteApi({ id: row.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}

.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}

.ticketUser {
  border-radius: 20px;
  border: 1px solid rgb(209, 209, 209);
  padding: 20px;
  margin-bottom: 10px;
  letter-spacing: 1px;
}
</style>
